'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = measurementsMapReducer;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _measurementsConstants = require('../../measurementsConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Lib
var initialState = Immutable.Map();

/**
 * Stores a map of measurements of target IDs.
 */


// Constants
function measurementsMapReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _measurementsConstants.MEASUREMENT_SET:
            return state.set(action.id, Immutable.fromJS(action.measurements));
        case _measurementsConstants.MEASUREMENT_REMOVE:
            return state.delete(action.id);
        default:
            return state;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/client/components/measurements/store/reducers/measurementsMapReducer.js
// module id = 1913
// module chunks = 0